export default __webpack_public_path__ + "static/media/survey-response-summary.1ca72669.svg";